import { BASE_URL } from "../../utils/url-builder";
import BaseService from "./base.service";

class StudentsService extends BaseService {
  constructor() {
    super(BASE_URL);
  }
  getStudents = (classId) =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await this.makeGetRequest(
          `admin/class/getUsers/learner/${classId}`
        );
        return resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });

  getClassRequests = async () => {
    return this.makeGetRequest(
      `student/get-class-requests`
    );
  };
}

const studentsService = new StudentsService();

export default studentsService;
